var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["layout-feedback", { "layout-feedback--open": _vm.showDialog }] },
    [
      !_vm.showDialog
        ? _c(
            "a",
            {
              staticClass: "layout-feedback--button",
              attrs: { href: "#" },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  _vm.showDialog = true
                }
              }
            },
            [
              _c("Icon", { attrs: { icon: "mail" } }),
              _vm._v("\n\t\tFeedback\n\t")
            ],
            1
          )
        : _c("div", { staticClass: "layout-feedback--dialog" }, [
            _c("header", [
              _c("div", [
                _vm._v("Fragen oder Anregungen? Wir freuen uns auf Feedback!")
              ]),
              _vm._v(" "),
              _c("div", [
                _c(
                  "a",
                  {
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        _vm.showDialog = false
                      }
                    }
                  },
                  [_c("Icon", { attrs: { icon: "close" } })],
                  1
                )
              ])
            ]),
            _vm._v(" "),
            _c(
              "main",
              [
                !_vm.isLoggedIn
                  ? _c("b-input", {
                      attrs: { placeholder: "E-Mail" },
                      model: {
                        value: _vm.email,
                        callback: function($$v) {
                          _vm.email = typeof $$v === "string" ? $$v.trim() : $$v
                        },
                        expression: "email"
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("b-textarea", {
                  attrs: { rows: 6, placeholder: "Deine Nachricht..." },
                  model: {
                    value: _vm.message,
                    callback: function($$v) {
                      _vm.message = $$v
                    },
                    expression: "message"
                  }
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "button-container" },
                  [
                    _c("Button", {
                      attrs: {
                        text: "Senden",
                        icon: "checkmark",
                        disabled: !_vm.dataValid || _vm.sending,
                        loading: _vm.sending
                      },
                      on: { click: _vm.send }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "footer",
              [
                _c("Icon", { attrs: { icon: "mail" } }),
                _vm._v("\n\t\t\tFeedback\n\t\t")
              ],
              1
            )
          ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }